<template>
    <div class="shopPage" v-loading="loading" element-loading-text="商品加载中..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.9)">
        <Bread :direct="direct" :bgc="bgc"></Bread>

        <div class="type_area">
            <div style="width:100%;text-align:right"> <el-button type="primary" style="margin-bottom:20px;" @click="buyAll">一键采购</el-button></div>
            <div style="height: 40px;background: #FFFFFF;display:flex;align-items:center;font-size: 14px;color: #333333;justify-content: space-between;">
                <div style="display:flex;align-items:center;margin-right:100px;width:420px;margin-left:10px;">
                    <el-checkbox style="margin-right:40px;" v-model="allChecked" @change="handleCheckAllChange">全选</el-checkbox>
                    <div style="">商品信息</div>
                </div>
                <div style="display:flex;align-items:center;flex:1;justify-content: space-around;text-align:center;">
                    <div style="width:200px;">单价</div>
                    <div style="width:200px;">数量</div>
                    <div style="width:100px;">金额</div>
                    <div style="width:200px;">操作</div>
                </div>
            </div>
            <div v-if="goodslist.length">
                <div v-for="(item,index) in goodslist" :key="index">
                    <div style="margin-top:20px;border:1px solid #EEEEEE;background: #fff;padding:10px;border-bottom:none;">
                        <el-checkbox @change="storeChecked(item.cartGoodsInfo,item.presellCartGoodsInfo,$event)" v-model="item.checked">{{ item.companyName }}</el-checkbox>
                        <div style="display:flex;align-items:center;text-align:center;justify-content: space-between;">
                            <div style="display:flex;align-items:center;flex:1;text-align:center;">
                                <div style="font-size: 16px;margin-right:20px;"><span style="vertical-align: middle;">商品总价：</span><span style="color:#F92B2B;font-weight: 600;vertical-align: middle;">￥{{item.totalPrice.toFixed(2)}}</span></div>
                                <div style="font-size: 16px;margin-right:20px;"> <el-tooltip effect="dark" placement="top">
                                        <div slot="content">
                                            <!-- <span v-for="(items,ind) in discountDetail" :key="ind" style="display:block;">
                                    {{items.preferPrice?'【'+items.productName+'】':''}}{{items.preferPrice?',立减'+items.preferPrice+'元':''}}<br v-if="items.preferPrice">
                                </span> -->
                                            <span v-for="(items,ind) in item.actNotice" :key="ind" style="display:block;">
                                                {{items.description}}
                                            </span>
                                        </div>
                                        <img style="vertical-align: middle;margin-right:5px; " :class="{'no-pointer':discountDetail.length===0}" src="../../assets/images/shopCar/explain.svg" alt="">
                                    </el-tooltip> <span style="vertical-align: middle;">优惠金额：</span><span style="font-weight: 600;color:#F92B2B;vertical-align: middle;">￥{{item.preferPrice.toFixed(2)}}</span></div>
                                <div style="font-size: 16px;"><span style="vertical-align: middle;">应付金额：</span><span style="font-size: 16px;color: #F92B2B;font-weight: 600;vertical-align: middle;">￥{{item.realPrice.toFixed(2)}}</span></div>
                            </div>
                            <div @click="explain(item,index)" v-if="!item.isShow" style="width:100px;height:30px;line-height:30px;text-align:center;border:1px solid #1a9dff;color:#1a9dff;cursor:pointer;">点击展开</div>
                            <div @click="explain(item,index)" v-else style="width:100px;height:30px;line-height:30px;text-align:center;border:1px solid #1a9dff;color:#1a9dff;cursor:pointer;">点击收起</div>
                        </div>
                    </div>
                    <div v-if="(item.cartGoodsInfo.length||item.presellCartGoodsInfo.length||item.invalidGoods.length)&&item.isShow" ref="shopCar" style="background: #FFFFFF; " :class="{'ispad':item.promotionGiftsSendInfo.length}">
                        <!-- <div style="display:flex;align-items:center;margin-bottom:20px;padding-top:20px;">
                    <div style="margin:0 10px;">
                        <el-checkbox v-model="checked"></el-checkbox>
                    </div>
                    <div>
                        <div style="font-weight: bold;font-size: 18px;color: #333333;">安徽华人健康股份有限公司</div>
                        <div style="font-size: 14px;color:#999999;">商品金额小计：<span style="color:#F92B2B;font-weight: 700;">￥29.1</span></div>
                    </div>
                </div> -->
                        <div v-for="(el,index) in item.cartGoodsInfo" :key="el.id" style="border: 1px solid #EEEEEE;padding: 0 0 10px;" :class="{'lastone':index!==item.cartGoodsInfo.length-1,'selected':el.cart.checked,}">
                            <div style="display:flex;align-items:center;">
                                <div style="display:flex;align-items:center;width:600px;">
                                    <div style="margin:0 10px;">
                                        <el-checkbox v-model="el.cart.checked" @change="changeChecked(el.cart.id,$event)"></el-checkbox>
                                    </div>
                                    <div style="position:relative;margin-top: 10px;cursor: pointer;" @click="goDetail(el.goodsSingleInfo.goodsId)">
                                        <img style="width:130px;height:130px;" :src="el.goodsSingleInfo.thumbUrl" alt="">
                                        <img v-if="el.goodsSingleInfo.stock==0" style="width:130px;height:130px;position:absolute;top:0;left:0;" src="../../assets/images/shopCar/soonGet.png" alt="">
                                    </div>
                                    <div style="font-size: 14px;color: #999999;margin-left:10px;height: 128px;">
                                        <div style="display:flex;align-items:center;margin-bottom:12px;cursor: pointer;" @click="goDetail(el.goodsSingleInfo.goodsId)">
                                            <div class="tejia" v-if="el.cart.actType==2">特价</div>
                                            <div class="mz" v-if="el.cart.actType==4">买赠</div>
                                            <div style="font-weight: bold;font-size: 16px;color: #333333;">{{el.goodsSingleInfo.productName}}</div>
                                        </div>
                                        <div style="margin-bottom: 5px;"><span style="display:inline-block;width:30px;margin-right: 10px;">厂商</span> <span style="color: #333333;">{{el.goodsSingleInfo.produceUnit}}</span></div>
                                        <div style="margin-bottom: 5px;" v-if="el.goodsSingleInfo.isExpired"><span style="display:inline-block;width:30px;margin-right: 10px;">效期</span> <span style="color:#FF6A05;">优于{{el.goodsSingleInfo.lastDate}}(近效期)</span></div>
                                        <div style="margin-bottom: 5px;" v-else><span style="display:inline-block;width:30px;margin-right: 10px;">效期</span> <span style="color: #333333;">优于{{el.goodsSingleInfo.lastDate}}</span></div>
                                        <div style="overflow:hidden;white-space:nowrap;margin-bottom: 5px;width:220px;text-overflow:ellipsis;"><span style="display:inline-block;width:30px;margin-right: 10px;">规格</span> <el-tooltip class="item" effect="dark" :disabled="el.goodsSingleInfo.norms.length<23" :content="el.goodsSingleInfo.norms" placement="top-start">
                                                <span style="color: #333333;">{{el.goodsSingleInfo.norms}}</span>
                                            </el-tooltip></div>
                                        <div><span style="display:inline-block;width:30px;margin-right: 10px;">库存</span> <span style="color: #333333;">{{el.goodsSingleInfo.stock}}</span></div>
                                    </div>
                                </div>
                                <div style="display:flex;align-items:center;flex:1;justify-content: space-around;text-align: center;">
                                    <div style="width:200px;">
                                        <div style="font-size: 18px;color: #F92B2B;">
                                            <div>￥{{(el.goodsSingleInfo.jiage).toFixed(2)}}
                                                <img v-if="el.priceFloatInfo.sign&&el.priceFloatInfo.diffType=='up'" style="width: 20px;height: 20px;vertical-align: sub;" src="../../assets/images/shopCar/up.svg" alt="">
                                                <img v-if="el.priceFloatInfo.sign&&el.priceFloatInfo.diffType=='down'" style="width: 20px;height: 20px;vertical-align: sub;" src="../../assets/images/shopCar/down.svg" alt="">
                                            </div>
                                            <div style="color:#333;font-size: 14px;text-decoration: line-through;" v-if="el.goodsSingleInfo.jiage!=el.goodsSingleInfo.price">￥{{(el.goodsSingleInfo.price).toFixed(2)}}</div>

                                        </div>
                                        <div v-if="el.priceFloatInfo.sign">
                                            <div style="font-size: 14px;" v-if="el.priceFloatInfo.diffType=='down'">较上次采购<span style="color:green;">降￥{{el.priceFloatInfo.diff}}</span></div>
                                            <div style="font-size: 14px;width:200px;" v-if="el.priceFloatInfo.diffType=='up'">较上次采购<span style="color:red;">涨￥{{el.priceFloatInfo.diff}}</span></div>
                                        </div>
                                    </div>
                                    <div style="text-align: center;width:200px;">
                                        <el-input-number style="width:140px;" @change="changeCount(el.cart.id,el.cart.quantity)" :step="el.goodsSingleInfo.step" v-model="el.cart.quantity" :min="1"></el-input-number>
                                        <div v-if="el.selectList&&el.selectList.length&&el.cart.useAct&&(el.goodsSingleInfo.bargain||(el.goodsSingleInfo.acts.length&&el.goodsSingleInfo.acts[0].actType==2)||(el.goodsSingleInfo.acts.length&&el.goodsSingleInfo.acts[0].actType==4))" style="font-size: 12px;color: #1A9DFF;">{{el.goodsSingleInfo.bargain||el.goodsSingleInfo.acts[0].description}}</div>
                                        <div style="font-size: 12px;color: #1A9DFF;" v-if="el.selectList&&el.selectList.length&&!el.cart.useAct">不参与优惠活动，不要赠品</div>
                                    </div>
                                    <div style="font-weight: bold;font-size: 18px;color: #F92B2B;width:100px;">￥{{(el.goodsSingleInfo.jiage*el.cart.quantity).toFixed(2)}}</div>
                                    <div>
                                        <el-select v-if="el.selectList&&el.selectList.length" class="select" v-model="el.cart.useAct" @change="selectChange(el,$event)" placeholder="请选择">
                                            <el-option v-for="ite in el.selectList" :key="ite.id" :label="ite.name" :value="ite.id">
                                            </el-option>
                                        </el-select>
                                        <div style="display:flex;align-items:center;font-size: 14px;color: #666666;width:200px;justify-content: center;">
                                            <el-popconfirm title="确定删除吗？" @onConfirm="deleteCar(el.cart.id)">
                                                <div class="delete" style="cursor: pointer;" slot="reference">删除</div>
                                            </el-popconfirm>
                                            <div style="width: 0px;height: 12px;border: 1px solid #EEEEEE;margin:0 10px;"></div>
                                            <div class="collect" style="cursor: pointer;" @click="collect(el.goodsSingleInfo)">{{el.goodsSingleInfo.favorite?'取消收藏':'收藏'}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-for="(ele,ind) in el.giftsSendInfo" :key="ind">
                                <div class="donate" v-if="ele.cart.actType!=9" style="margin-top:10px;">
                                    <div style="display:flex;align-items:center;margin-right:100px;margin-left:10px;"><img src="../../assets/images/shopCar/donate.svg" alt="">
                                        <div style="margin-left:10px;width:100px;">【赠品】</div>
                                    </div>
                                    <div style="width:300px;">{{ele.goodsSingleInfo.productName}}</div>
                                    <div style="width:300px;">优于{{ele.goodsSingleInfo.lastDate}}</div>
                                    <div style="width:200px;">{{ele.goodsSingleInfo.norms}}</div>
                                    <div style="width:300px;">{{ele.cart.quantity}}{{ele.goodsSingleInfo.unit}}</div>
                                    <div style="width:18px;height:18px;"><img src="../../assets/images/orderInfo/yellowright.svg" alt=""></div>
                                </div>
                                <div class="donate-pink" v-if="ele.cart.actType==9" style="margin-top:10px;">
                                    <div style="display:flex;align-items:center;margin-right:100px;margin-left:10px;"><img src="../../assets/images/shopCar/giftPink.svg" alt="">
                                        <div style="margin-left:10px;width:100px;">【物料礼袋】</div>
                                    </div>
                                    <div style="width:300px;">{{ele.goodsSingleInfo.productName}}</div>
                                    <div style="width:300px;">优于{{ele.goodsSingleInfo.lastDate}}</div>
                                    <div style="width:200px;">{{ele.goodsSingleInfo.norms}}</div>
                                    <div style="width:300px;">{{ele.cart.quantity}}{{ele.goodsSingleInfo.unit}}</div>
                                    <div style="width:18px;height:18px;"><img src="../../assets/images/shopCar/rightPink.svg" alt=""></div>
                                </div>
                            </div>
                        </div>
                        <div v-for="(pre,index) in item.presellCartGoodsInfo" :key="pre.id" style="border: 1px solid #EEEEEE;padding: 0 0 10px;" :class="{'lastone':index!==item.presellCartGoodsInfo.length-1,'selected':pre.cart.checked,'firstone':item.cartGoodsInfo.length&&index==0}">
                            <div style="display:flex;align-items:center;">
                                <div style="display:flex;align-items:center;width:600px;">
                                    <div style="margin:0 10px;">
                                        <el-checkbox v-model="pre.cart.checked" @change="changeChecked(pre.cart.id,$event)"></el-checkbox>
                                    </div>
                                    <div style="position:relative;margin-top: 10px;cursor: pointer;" @click="goPreDetail(pre.goodsSingleInfo.goodsId)">
                                        <img style="width:130px;height:130px;" :src="pre.goodsSingleInfo.thumbUrl" alt="">
                                        <img v-if="pre.goodsSingleInfo.stock==0" style="width:130px;height:130px;position:absolute;top:0;left:0;" src="../../assets/images/shopCar/soonGet.png" alt="">
                                    </div>
                                    <div style="font-size: 14px;color: #999999;margin-left:10px;height: 128px;">
                                        <div style="display:flex;align-items:center;margin-bottom:12px;cursor: pointer;" @click="goPreDetail(pre.goodsSingleInfo.goodsId)">
                                            <div class="tejia" v-if="pre.cart.actType==2">特价</div>
                                            <div class="mz" v-if="pre.cart.actType==4">买赠</div>
                                            <img src="../../assets/images/shopCar/spre.svg" style="margin-right:5px;" v-if="pre.cart.actType==10" alt="">
                                            <div style="font-weight: bold;font-size: 16px;color: #333333;">{{pre.goodsSingleInfo.productName}}</div>
                                        </div>
                                        <div style="margin-bottom: 5px;"><span style="display:inline-block;width:30px;margin-right: 10px;">厂商</span> <span style="color: #333333;">{{pre.goodsSingleInfo.produceUnit}}</span></div>
                                        <div style="margin-bottom: 5px;" v-if="pre.goodsSingleInfo.isExpired"><span style="display:inline-block;width:30px;margin-right: 10px;">效期</span> <span style="color:#FF6A05;">优于{{pre.goodsSingleInfo.lastDate}}(近效期)</span></div>
                                        <div style="margin-bottom: 5px;" v-else><span style="display:inline-block;width:30px;margin-right: 10px;">效期</span> <span style="color: #333333;">{{pre.goodsSingleInfo.lastDate}}</span></div>
                                        <div style="overflow:hidden;white-space:nowrap;margin-bottom: 5px;width:220px;text-overflow:ellipsis;"><span style="display:inline-block;width:30px;margin-right: 10px;">规格</span> <el-tooltip class="item" effect="dark" :disabled="pre.goodsSingleInfo.norms.length<23" :content="pre.goodsSingleInfo.norms" placement="top-start">
                                                <span style="color: #333333;">{{pre.goodsSingleInfo.norms}}</span>
                                            </el-tooltip></div>
                                        <div><span style="display:inline-block;width:30px;margin-right: 10px;">库存</span> <span style="color: #333333;">{{pre.goodsSingleInfo.stock}}</span></div>
                                    </div>
                                </div>
                                <div style="display:flex;align-items:center;flex:1;justify-content: space-around;text-align: center;position:relative;">
                                    <div class="bpre">{{pre.goodsSingleInfo.acts[0].title+'到货'}}</div>
                                    <div style="width:200px;">
                                        <div style="font-size: 18px;color: #F92B2B;">
                                            <div>￥{{(pre.goodsSingleInfo.jiage).toFixed(2)}}
                                                <img v-if="pre.priceFloatInfo.sign&&pre.priceFloatInfo.diffType=='up'" style="width: 20px;height: 20px;vertical-align: sub;" src="../../assets/images/shopCar/up.svg" alt="">
                                                <img v-if="pre.priceFloatInfo.sign&&pre.priceFloatInfo.diffType=='down'" style="width: 20px;height: 20px;vertical-align: sub;" src="../../assets/images/shopCar/down.svg" alt="">
                                            </div>
                                            <!-- <div style="color:#333;font-size: 14px;text-decoration: line-through;" v-if="pre.goodsSingleInfo.jiage!=pre.goodsSingleInfo.price">￥{{(pre.goodsSingleInfo.price).toFixed(2)}}</div> -->

                                        </div>
                                        <div v-if="pre.priceFloatInfo.sign">
                                            <div style="font-size: 14px;" v-if="pre.priceFloatInfo.diffType=='down'">较上次采购<span style="color:green;">降￥{{pre.priceFloatInfo.diff}}</span></div>
                                            <div style="font-size: 14px;width:200px;" v-if="pre.priceFloatInfo.diffType=='up'">较上次采购<span style="color:red;">涨￥{{pre.priceFloatInfo.diff}}</span></div>
                                        </div>
                                    </div>
                                    <div style="text-align: center;width:200px;">
                                        <el-input-number style="width:140px;" @change="changeCount(pre.cart.id,pre.cart.quantity)" :step="pre.goodsSingleInfo.step" v-model="pre.cart.quantity" :min="1"></el-input-number>
                                        <div v-if="pre.spreectList&&el.selectList.length&&pre.cart.useAct&&(pre.goodsSingleInfo.bargain||(pre.goodsSingleInfo.acts.length&&pre.goodsSingleInfo.acts[0].actType==2)||(pre.goodsSingleInfo.acts.length&&pre.goodsSingleInfo.acts[0].actType==4))" style="font-size: 12px;color: #1A9DFF;">{{pre.goodsSingleInfo.bargain||pre.goodsSingleInfo.acts[0].description}}</div>
                                        <div style="font-size: 12px;color: #1A9DFF;" v-if="pre.selectList&&pre.selectList.length&&!pre.cart.useAct">不参与优惠活动，不要赠品</div>
                                    </div>
                                    <div style="font-weight: bold;font-size: 18px;color: #F92B2B;width:100px;">￥{{(pre.goodsSingleInfo.jiage*pre.cart.quantity).toFixed(2)}}</div>
                                    <div>
                                        <el-select v-if="pre.selectList&&pre.selectList.length" class="select" v-model="pre.cart.useAct" @change="selectChange(pre,$event)" placeholder="请选择">
                                            <el-option v-for="ites in pre.selectList" :key="ites.id" :label="ites.name" :value="ites.id">
                                            </el-option>
                                        </el-select>
                                        <div style="display:flex;align-items:center;font-size: 14px;color: #666666;width:200px;justify-content: center;">
                                            <el-popconfirm title="确定删除吗？" @onConfirm="deleteCar(pre.cart.id)">
                                                <div class="delete" style="cursor: pointer;" slot="reference">删除</div>
                                            </el-popconfirm>
                                            <div v-if="pre.goodsSingleInfo.acts[0].actType!=10" style="width: 0px;height: 12px;border: 1px solid #EEEEEE;margin:0 10px;"></div>
                                            <div v-if="pre.goodsSingleInfo.acts[0].actType!=10" class="collect" style="cursor: pointer;" @click="collect(pre.goodsSingleInfo)">{{pre.goodsSingleInfo.favorite?'取消收藏':'收藏'}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-for="(eles,ind) in pre.giftsSendInfo" :key="ind">
                                <div class="donate" v-if="eles.cart.actType!=9" style="margin-top:10px;">
                                    <div style="display:flex;align-items:center;margin-right:100px;margin-left:10px;"><img src="../../assets/images/shopCar/donate.svg" alt="">
                                        <div style="margin-left:10px;width:100px;">【赠品】</div>
                                    </div>
                                    <div style="width:300px;">{{eles.goodsSingleInfo.productName}}</div>
                                    <div style="width:300px;">优于{{eles.goodsSingleInfo.lastDate}}</div>
                                    <div style="width:200px;">{{eles.goodsSingleInfo.norms}}</div>
                                    <div style="width:300px;">{{eles.cart.quantity}}{{eles.goodsSingleInfo.unit}}</div>
                                    <div style="width:18px;height:18px;"><img src="../../assets/images/orderInfo/yellowright.svg" alt=""></div>
                                </div>
                                <div class="donate-pink" v-if="eles.cart.actType==9" style="margin-top:10px;">
                                    <div style="display:flex;align-items:center;margin-right:100px;margin-left:10px;"><img src="../../assets/images/shopCar/giftPink.svg" alt="">
                                        <div style="margin-left:10px;width:100px;">【物料礼袋】</div>
                                    </div>
                                    <div style="width:300px;">{{eles.goodsSingleInfo.productName}}</div>
                                    <div style="width:300px;">优于{{eles.goodsSingleInfo.lastDate}}</div>
                                    <div style="width:200px;">{{eles.goodsSingleInfo.norms}}</div>
                                    <div style="width:300px;">{{eles.cart.quantity}}{{eles.goodsSingleInfo.unit}}</div>
                                    <div style="width:18px;height:18px;"><img src="../../assets/images/shopCar/rightPink.svg" alt=""></div>
                                </div>
                            </div>
                        </div>
                        <div class="donate" style="margin-top:10px;" v-for="(els,indexs) in item.promotionGiftsSendInfo" :key="indexs">
                            <div style="display:flex;align-items:center;margin-right:100px;margin-left:10px;"><img src="../../assets/images/shopCar/donate.svg" alt="">
                                <div style="margin-left:10px;width:100px;">【赠品】</div>
                            </div>
                            <div style="width:300px;">{{els.goodsSingleInfo.productName}}</div>
                            <div style="width:300px;">优于{{els.goodsSingleInfo.lastDate}}</div>
                            <div style="width:200px;">{{els.goodsSingleInfo.norms}}</div>
                            <div style="width:300px;">{{els.cart.quantity}}{{els.goodsSingleInfo.unit}}</div>
                            <div style="width:18px;height:18px;"><img src="../../assets/images/orderInfo/yellowright.svg" alt=""></div>
                        </div>
                        <!-- 失效商品 -->
                        <div v-if="item.invalidGoods.length">
                            <div style="background:#f7f8fa;padding:10px;border-bottom:none;display:flex;align-items:center;">
                                <span style="font-size:14px;color:#707070;">已失效</span>
                                <el-popconfirm title="确定删除全部失效商品吗？" @onConfirm="deleteInvalid(item)">
                                    <span style="font-size:14px;color:#1A9DFF;margin-left:20px;cursor:pointer;" slot="reference">全部删除</span>
                                </el-popconfirm>
                            </div>
                            <div v-for="(el,index) in item.invalidGoods" :key="'invalid'+el.cart.id" style="border:1px solid #EEEEEE;background:#FFFFFF;padding:0 0 10px;" :class="{'lastone':index!==item.invalidGoods.length-1}">
                                <div style="display:flex;align-items:center;">
                                    <div style="display:flex;align-items:center;">
                                        <div style="position:relative;margin:10px 0 0 40px;">
                                            <img style="width:130px;height:130px;" :src="el.goodsSingleInfo.thumbUrl" alt="">
                                            <img v-if="el.goodsSingleInfo.stock==0" style="width:130px;height:130px;position:absolute;top:0;left:0;" src="../../assets/images/shopCar/soonGet.png" alt="">
                                        </div>
                                        <div style="font-size:14px;color:#999999;margin-left:10px;height:128px;">
                                            <div style="margin-bottom:12px;">
                                                <div style="font-weight:bold;font-size:16px;color:#333333;">{{el.goodsSingleInfo.productName}}</div>
                                            </div>
                                            <div style="margin-bottom:5px;"><span style="display:inline-block;width:30px;margin-right:10px;">厂商</span> <span style="color:#333333;">{{el.goodsSingleInfo.produceUnit}}</span></div>
                                            <div style="margin-bottom:5px;" v-if="el.goodsSingleInfo.isExpired"><span style="display:inline-block;width:30px;margin-right:10px;">效期</span> <span style="color:#FF6A05;">优于{{el.goodsSingleInfo.lastDate}}(近效期)</span></div>
                                            <div style="margin-bottom:5px;" v-else><span style="display:inline-block;width:30px;margin-right:10px;">效期</span> <span style="color:#333333;">优于{{el.goodsSingleInfo.lastDate}}</span></div>
                                            <div style="overflow:hidden;white-space:nowrap;margin-bottom:5px;width:220px;text-overflow:ellipsis;"><span style="display:inline-block;width:30px;margin-right:10px;">规格</span> <span style="color:#333333;">{{el.goodsSingleInfo.norms}}</span></div>
                                            <div><span style="display:inline-block;width:30px;margin-right:10px;">库存</span> <span style="color:#333333;">{{el.goodsSingleInfo.stock}}</span></div>
                                        </div>
                                    </div>
                                    <div style="flex:1;text-align:right;padding-right:30px;">
                                        <el-popconfirm title="确定删除吗？" @onConfirm="deleteCar(el.cart.id)">
                                            <div class="delete" style="font-size:14px;color:#707070;cursor:pointer;display:inline-block;" slot="reference">删除</div>
                                        </el-popconfirm>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="(!item.presellCartGoodsInfo.length&&!item.cartGoodsInfo.length&&!item.invalidGoods.length)&&item.isShow">
                        <div class="nodata_box">
                            <img src="@/assets/images/index/nodata.png" alt="">
                            <span>暂无数据哦~</span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div slot="empty" class="nodata_box">
                    <img src="@/assets/images/index/nodata.png" />
                    <span class="txt">暂无数据哦~</span>
                </div>
            </div>
            <div ref="carPay" class="car-pay" style="height: 66px;z-index:99;width:1200px;background: #FFFFFF;display:flex;align-items:center;font-size: 14px;color: #333333;justify-content: space-between;margin-top:10px;">
                <div style="display:flex;align-items:center;margin-right:100px;width:400px;margin-left:10px;">
                    <el-checkbox style="margin-right:40px;" v-model="allChecked" @change="handleCheckAllChange">全选</el-checkbox>
                    <div style="display:flex;align-items:center;font-size: 14px;color: #666666;width:200px;justify-content: center;">
                        <el-popconfirm title="确定删除吗？" @onConfirm="deleteCar('checked')">
                            <div style="cursor: pointer;" slot="reference">删除</div>
                        </el-popconfirm>
                        <div style="width: 0px;height: 12px;border: 1px solid #EEEEEE;margin:0 10px;"></div>
                        <el-popconfirm title="确定清空采购车吗？" @onConfirm="clearCar">
                            <div style="cursor: pointer;" slot="reference">清空采购车</div>
                        </el-popconfirm>
                    </div>
                </div>
                <div style="display:flex;align-items:center;flex:1;justify-content: space-between;text-align:center;">
                    <div style="font-size: 16px;"><span style="vertical-align: middle;">商品总价：</span><span style="color:#F92B2B;font-weight: 600;vertical-align: middle;">￥{{totalPrice.toFixed(2)}}</span></div>
                    <div style="font-size: 16px;"> <el-tooltip effect="dark" placement="top">
                            <div slot="content">
                                <span v-for="(items,ind) in discountDetail" :key="ind" style="display:block;">
                                    {{ items.description }}
                                </span>
                            </div>
                            <img style="vertical-align: middle;margin-right:5px; " :class="{'no-pointer':discountDetail.length===0}" src="../../assets/images/shopCar/explain.svg" alt="">
                        </el-tooltip> <span style="vertical-align: middle;">优惠金额：</span><span style="font-weight: 600;color:#F92B2B;vertical-align: middle;">￥{{preferPrice.toFixed(2)}}</span></div>
                    <div style="font-size: 16px;"><span style="vertical-align: middle;">应付金额：</span><span style="font-size: 22px;color: #F92B2B;font-weight: 700;vertical-align: middle;">￥{{realPrice.toFixed(2)}}</span></div>
                    <div style="width: 155px;height: 66px;background: #1A9DFF;font-weight: bold;font-size: 22px;color: #FFFFFF;text-align: center;line-height: 66px;cursor: pointer;" @click="goPay">去结算</div>
                </div>
            </div>
        </div>
        <el-dialog :visible="noticeVisible" center="center" title="提示" width="22%" class="else-dialog" @close="noticeclosed">
            <div v-for="(item,index) in notice" :key="index">
                <div style="font-size:16px;margin-bottom:10px;">{{item.companyName}}</div>
                <div v-for="(items,indexs) in item.cartNoticeResp" :key="indexs" class="sketch_content" style="font-size:16px;margin-bottom:10px;">
                    <div style="color:red;font-weight:600">
                        <span>{{items.message}}</span>
                    </div>
                    <div style="padding: 0 10px;" v-for="(el,ind) in items.goodsInfo" :key="ind">
                        <span>{{ind+1}}.</span><span>{{el}}</span>
                    </div>
                </div>
            </div>

        </el-dialog>
        <el-dialog title="" :visible.sync="dateDialog" width="40%" @close="handleClose">
            <div style=" margin-bottom:30px;" v-if="dateArr.length">
                <div style="font-size: 18px;color: #303133;margin-bottom:10px;">
                    <i class="el-icon-warning" style="color:#faad14;"></i> 所选商品有近效期商品
                </div>
                <div v-for="(item,index) in dateArr" :key="index" style="margin-bottom:10px;color:#FF6A05;font-size:16px;">
                    <span>{{index+1}}.{{ item.company }} </span>
                    <span style="color:#333;">{{item.goods.goodsSingleInfo.productName}}</span>
                    优于{{item.goods.goodsSingleInfo.lastDate}}（近效期）
                </div>
            </div>
            <div v-if="floatArr.length">
                <div style="font-size: 18px;color: #303133;margin-bottom:10px;"> <i class="el-icon-warning" style="color:#faad14;"></i> 所选商品中有价格变动商品</div>
                <div v-for="(item,index) in floatArr" :key="index" style="margin-bottom:10px;color:#FF6A05;font-size:16px;">
                    <span>{{index+1}}.{{ item.company }} </span>
                    <span style="color:#333;">{{item.goods.priceFloatInfo.productName}} 较上次采购
                        <span v-if="item.goods.priceFloatInfo.diffType=='down'" style="color:green;">降￥{{item.goods.priceFloatInfo.diff}}</span>
                        <span v-if="item.goods.priceFloatInfo.diffType=='up'" style="color:#FF6A05;">涨￥{{item.goods.priceFloatInfo.diff}}</span>
                    </span>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dateDialog = false">重选商品</el-button>
                <el-button type="primary" @click="payContune">继续下单</el-button>
            </span>
        </el-dialog>

        <!-- 一键采购弹框 -->
        <el-dialog title="一键采购" :visible.sync="buyAllDialog" width="60%" @close="handleBuyAllClose">
            <div class="buy-all-steps">
                <!-- 步骤1：下载模板 -->
                <div class="step-item">
                    <div class="step-number">1</div>
                    <div class="step-content">
                        <div class="step-title">下载模板</div>
                        <div class="step-desc">点击【下载导入模板】按钮，可下载导入模板</div>
                        <el-button type="primary" style="margin-top: 10px;" @click="downloadTemplate">下载导入模板</el-button>
                    </div>
                </div>

                <!-- 步骤2：选择门店 -->
                <div class="step-item" v-if="$store.state.memberInfo.isMain == 1">
                    <div class="step-number">2</div>
                    <div class="step-content">
                        <div class="step-title">选择门店</div>
                        <div class="step-desc">请至少选择一个门店进行数据导入</div>
                        <div class="store-list">
                            <div v-for="store in stores" :key="store.memberCode" class="store-item">
                                <el-checkbox v-model="store.checked">{{ store.companyName }}</el-checkbox>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 步骤3：上传文件 -->
                <div class="step-item">
                    <div class="step-number">{{ $store.state.memberInfo.isMain == 1 ? '3' : '2'}}</div>
                    <div class="step-content">
                        <div class="step-title">上传文件</div>
                        <div class="step-desc">按模板格式，选择文件上传，仅支持扩展名为：.xls或.xlsx格式且文件大小不超过2M</div>
                        <div class="upload-area">
                            <el-upload class="upload-demo" action="" :auto-upload="false" :on-change="handleFileChange" :show-file-list="false">
                                <el-button size="small" type="primary">选择文件</el-button>
                            </el-upload>
                            <el-button size="small" type="success" :disabled="!selectedFile" @click="importFile" style="margin-top: 10px;">导入文件</el-button>
                        </div>
                        <div v-if="uploadedFileName" class="file-name">
                            <i class="el-icon-document"></i> {{ uploadedFileName }}
                        </div>
                    </div>
                </div>

                <!-- 步骤4：导入结果 -->
                <div class="step-item" v-if="importResult.completed">
                    <div class="step-number">4</div>
                    <div class="step-content">
                        <div class="step-title">导入结果</div>
                        <div class="result-summary">
                            <el-tag type="success" effect="dark">导入完成</el-tag>
                            <span style="margin-left: 10px;">成功了{{ importResult.success }}条，失败了{{ importResult.failed }}条</span>
                            <el-button size="small" type="primary" style="margin-left: 20px;" @click="exportResult">导出</el-button>
                        </div>
                        <div class="result-table">
                            <el-table :data="importResult.details" style="width: 100%; margin-top: 15px;">
                                <el-table-column type="index" label="序号" width="80"></el-table-column>
                                <el-table-column prop="goodsCode" label="商品编码"></el-table-column>
                                <el-table-column prop="goodInfo" label="商品名称"></el-table-column>
                                <el-table-column prop="companyName" label="失败门店"></el-table-column>
                                <el-table-column prop="message" label="错误原因"></el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="buyAllDialog = false">关闭</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
import Bread from '@/components/Bread'
import { downloadExcel } from '@/utils/common'
import scrollMixin from '@/minix/scrollEvent'
import { getCarNum } from '@/utils/carNumber'
export default {
    components: {
        Bread
    },
    mixins: [scrollMixin],
    data() {
        return {
            direct: ['首页', '采购车'],
            bgc: '#f3f3f3',
            preferPrice: '',
            realPrice: '',
            totalPrice: '',
            list: [],
            allChecked: false,
            discountDetail: [],
            offsetTop: 0,
            shopHeight: 0,
            promotionGiftsSendInfo: [],
            noticeVisible: false,
            isShow: false,
            notice: [],
            dateDialog: false,
            loading: true,
            dateArr: [],
            floatArr: [],
            preChecked: [],
            goodslist: [


            ],
            // 一键采购弹框相关
            buyAllDialog: false,
            stores: [

            ],
            selectedFile: null,
            importResult: {
                success: 0,
                failed: 0,
                completed: false,
                details: []
            },
            uploadedFileName: '',
            responseId: '',
        }
    },
    async created() {
        await this.getShopCar()
        this.update()
    },
    mounted() {
        // setInterval(() => {
        //     this.update()
        // }, 200);
    },
    // updated() {
    //     this.update()
    // },
    // computed: {
    //     allChecked: {
    //         get() {
    //             if (this.goodslist.length == 0) return false
    //             return this.goodslist.every(item => item.checked)
    //         },
    //         set(val) {
    //             this.goodslist.forEach(item => {
    //                 item.checked = val
    //             })
    //         }
    //     }
    // },
    methods: {
        update() {
            this.isShow = !this.isShow
            this.$nextTick(() => {
                console.log(this.$refs.carPay.offsetTop);
                this.offsetTop = this.$refs.carPay.offsetTop
                this.shopHeight = this.$refs.shopCar.offsetHeight
                if (document.documentElement.scrollTop + window.innerHeight >= this.offsetTop) {
                    document.querySelector('.car-pay').style.position = 'relative'
                    document.querySelector('.car-pay').style.boxShadow = '0px 0px 0px 0px rgba(0, 0, 0, 0)'
                } else {
                    document.querySelector('.car-pay').style.position = 'fixed'
                    document.querySelector('.car-pay').style.bottom = '0'
                    document.querySelector('.car-pay').style.boxShadow = '0px -10px 10px 0px rgba(0, 0, 0, 0.1)'
                }

                if (this.offsetTop == 853 && this.isShow) {
                    this.update()
                }
            })
        },
        noticeclosed() {
            this.noticeVisible = false
        },
        downloadTemplate() {
            window.open('https://b2b-img.hrjkjt.com/batchCarFile.xlsx?t=' + new Date().getTime())
        },
        handleClose() {

            this.dateArr = []
            this.floatArr = []
            this.dateDialog = false
        },
        explain(item, index) {
            // this.isShow=!this.isShow
            item.isShow = !item.isShow
            sessionStorage.setItem('explain' + index, item.isShow)
            setTimeout(() => {
                this.update()
            }, 200);

        },
        async exportResult() {
            const res = await this.$api.exportFailData({
                responseId: this.responseId
            })
            downloadExcel(res, '采购车导入失败数据' + new Date().getTime())
        },
        payContune() {
            this.dateDialog = false
            // this.$router.push('/orderInfo?isPreSell=' + this.preChecked.length ? 1 : 0)
            this.$router.push(`/orderInfo?isPreSell=${this.preChecked.length ? 1 : 0}`)
        },
        //单选
        async changeChecked(id, val) {
            console.log(id, val);
            await this.$orderApis.multipleCartSelect({
                cartIds: [id],
                checked: val ? 1 : 0,
                allChecked: 0
            })
            this.getShopCar()
            // this.update()
        },
        async storeChecked(arr, presellArr, val) {
            console.log(arr, presellArr, val);
            const ids = arr.map(item => item.cart.id)
            const presellIds = presellArr.map(item => item.cart.id)
            await this.$orderApis.multipleCartSelect({
                cartIds: ids.concat(presellIds),
                checked: val ? 1 : 0,
                allChecked: 0
            })
            this.getShopCar()
            // this.update()
        },
        async handleCheckAllChange(val) {
            console.log(val);
            await this.$orderApis.multipleCartSelect({
                cartIds: [],
                checked: 1,
                allChecked: val ? 1 : -1
            })
            this.getShopCar()
            // this.update()
        },
        //数量改变
        async changeCount(id, count) {
            await this.$orderApis.changeNum({
                cartId: id,
                num: count
            })
            this.getShopCar()
            // this.update()
        },
        async selectChange(el) {
            console.log(el);
            const res = await this.$orderApis.giveSelect({
                cartId: el.cart.id,
                useAct: el.cart.useAct
            })
            if (res.data.code == 200) {
                this.getShopCar()
            }
        },
        //详情
        async getShopCar() {
            this.loading = true
            getCarNum(this)
            const res = await this.$orderApis.multipleCartList().catch(() => null)
            if (res && res.data.code == 200) {
                res.data.data.cartInfo.forEach((item, index) => {
                    if (index == 0) {
                        item.isShow = sessionStorage.getItem('explain' + index) == null || sessionStorage.getItem('explain' + index) == undefined ? true : JSON.parse(sessionStorage.getItem('explain' + index))
                    } else {
                        item.isShow = sessionStorage.getItem('explain' + index) == null || sessionStorage.getItem('explain' + index) == undefined ? false : JSON.parse(sessionStorage.getItem('explain' + index))
                    }
                    if (item.checked) {
                        item.checked = true
                    } else {
                        item.checked = false
                    }
                    item.cartGoodsInfo.forEach((item1) => {
                        if (item1.goodsSingleInfo.acts.length && item1.goodsSingleInfo.acts[0].actType == 4) {
                            item1.selectList = [{
                                name: item1.goodsSingleInfo.acts[0].description,
                                id: 1
                            },
                            {
                                name: '不参与优惠活动，不要赠品',
                                id: 0
                            }
                            ]

                        }
                        item1.goodsSingleInfo.step = item1.goodsSingleInfo.startingPurchase
                        // item1.goodsSingleInfo.Pack.forEach(items => {
                        //     if (items.isPack == 'on') {
                        //         item1.goodsSingleInfo.step = +items.num
                        //     } else {
                        //         item1.goodsSingleInfo.step = +item1.goodsSingleInfo.Pack[0].num
                        //     }
                        // })
                        if (item1.cart.checked) {
                            item1.cart.checked = true
                        } else {
                            item1.cart.checked = false
                        }
                    })
                    item.presellCartGoodsInfo.forEach((item2) => {
                        if (item2.goodsSingleInfo.acts.length && item2.goodsSingleInfo.acts[0].actType == 4) {
                            item2.selectList = [{
                                name: item2.goodsSingleInfo.acts[0].description,
                                id: 1
                            },
                            {
                                name: '不参与优惠活动，不要赠品',
                                id: 0
                            }
                            ]

                        }
                        item2.goodsSingleInfo.step = item2.goodsSingleInfo.startingPurchase
                        // item2.goodsSingleInfo.Pack.forEach(items => {
                        //     if (items.isPack == 'on') {
                        //         item2.goodsSingleInfo.step = +items.num
                        //     } else {
                        //         item2.goodsSingleInfo.step = +item2.goodsSingleInfo.Pack[0].num
                        //     }
                        // })
                        if (item2.cart.checked) {
                            item2.cart.checked = true
                        } else {
                            item2.cart.checked = false
                        }
                    })

                    // 拆分失效商品，单独排列
                    item.invalidGoods = item.cartGoodsInfo.filter(g => g.isInvalid)
                        .concat(item.presellCartGoodsInfo.filter(g => g.isInvalid))
                    item.cartGoodsInfo = item.cartGoodsInfo.filter(g => !g.isInvalid)
                    item.presellCartGoodsInfo = item.presellCartGoodsInfo.filter(g => !g.isInvalid)

                })
                this.goodslist = res.data.data.cartInfo
                this.discountDetail = res.data.data.actNotice
                this.allChecked = res.data.data.allChecked ? true : false
                console.log(this.goodslist, 's');
                // this.list = res.data.data.cartInfo.cartGoodsInfo
                // this.list.forEach(item => {
                //     item.goodsSingleInfo.Pack.forEach(items => {
                //         if (items.isPack == 'on') {
                //             item.goodsSingleInfo.step = +items.num
                //         } else {
                //             item.goodsSingleInfo.step = +item.goodsSingleInfo.Pack[0].num
                //         }
                //     })


                //     if (item.cart.checked) {
                //         item.cart.checked = true
                //     } else {
                //         item.cart.checked = false
                //     }
                // })
                // res.data.data.cartInfo.cartActInfo.forEach((item) => {
                //     if (item.actType != 4) {
                //         item.goodsInfo.forEach(el => {
                //             this.discountDetail.push(el)
                //         })
                //     }
                // })
                this.preferPrice = res.data.data.preferPrice
                this.realPrice = res.data.data.realPrice
                this.totalPrice = res.data.data.totalPrice
                // this.promotionGiftsSendInfo = res.data.data.cartInfo.promotionGiftsSendInfo
                this.notice = res.data.data.multipleCartNotice
                if (this.notice.length > 0) {
                    this.noticeVisible = true
                }
            }
            // 数据渲染完成后再关闭加载动画
            this.$nextTick(() => {
                this.loading = false
            })
        },
        //点击收藏
        async collect(item) {
            const res = await this.$orderApis.collect({
                goodsId: item.goodsId
            })
            if (res.data.code !== 200) return
            item.favorite = !item.favorite
            item.favorite ? this.$message({
                message: '收藏成功',
                type: "success"
            }) : this.$message('取消收藏成功')
            // this.update()
        },
        async clearCar() {
            const res = await this.$orderApis.deleteCart(
                {
                    clearable: 1,
                    cartId: []
                }
            )
            if (res.data.code !== 200) return
            this.$message({
                type: 'success', // success error warning
                message: '清空成功'
            })
            this.getShopCar()
        },
        async deleteCar(id) {
            if (id == 'checked') {
                console.log(this.goodslist);
                const cartId = []
                const checked = this.goodslist.filter(item => item.checked)
                checked.forEach(item => {
                    item.cartGoodsInfo.forEach(item1 => {
                        if (item1.cart.checked) {
                            cartId.push(item1.cart.id)
                        }
                    })
                    item.presellCartGoodsInfo.forEach(item2 => {
                        if (item2.cart.checked) {
                            cartId.push(item2.cart.id)
                        }
                    })
                })

                console.log(checked);
                const res = await this.$orderApis.deleteCart(
                    {
                        clearable: 0,
                        cartId: cartId
                    }
                )
                if (res.data.code !== 200) return
            } else {
                const res = await this.$orderApis.deleteCart(
                    {
                        clearable: 0,
                        cartId: [id]
                    }
                )
                if (res.data.code !== 200) return
            }

            this.$message({
                type: 'success', // success error warning
                message: '删除成功'
            })
            this.getShopCar()

        },
        //删除全部失效商品
        async deleteInvalid(item) {
            if (!item.invalidGoods.length) return
            const cartId = item.invalidGoods.map(g => g.cart.id)
            const res = await this.$orderApis.deleteCart({
                clearable: 0,
                cartId: cartId
            })
            if (res.data.code !== 200) return
            this.$message({
                type: 'success', // success error warning
                message: '删除成功'
            })
            this.getShopCar()
        },
        async goPay() {
            // const checked = this.goodslist.filter(item => item.cart.checked)
            // const cartId = []
            const checked = this.goodslist.filter(item => item.checked)
            this.preChecked = []
            const normalChecked = []
            checked.forEach((item) => {
                item.preChecked = []
                item.presellCartGoodsInfo.forEach(item1 => {
                    if (item1.cart.checked) {
                        this.preChecked.push(item1)
                        item.preChecked.push(item1)
                    }
                })
                item.cartGoodsInfo.forEach(item1 => {
                    if (item1.cart.checked) {
                        normalChecked.push(item1)
                    }
                })
            })
            if (checked.length === 0) return this.$message({
                type: 'warning', // success error warning
                message: '请选择商品'
            })
            const res = await this.$api.checkCart()
            if (res.data.code !== 200) return
            // if()
            // const  isOne= 
            if (this.preChecked.length && normalChecked.length) {
                this.$message({
                    type: 'warning', // success error warning
                    message: '预售商品和普通商品不能同时结算'
                })
                return
            }
            // if (checked.some(item => item.preChecked.length > 1)) {
            //     this.$message({
            //         type: 'warning', // success error warning
            //         message: '预售商品订单只允许一种预售商品'
            //     })
            //     return
            // }
            // if (this.preChecked.length > 1) {
            //     this.$message({
            //         type: 'warning', // success error warning
            //         message: '预售商品订单只允许一种预售商品'
            //     })
            //     return
            // }
            checked.forEach(item => {
                item.cartGoodsInfo.forEach(item1 => {

                    if (item1.goodsSingleInfo.isExpired == 1 && item1.cart.checked) {
                        this.dateArr.push({ company: item.companyName, goods: item1 })
                    }
                    if (item1.priceFloatInfo.sign && item1.cart.checked) {
                        this.floatArr.push({ company: item.companyName, goods: item1 })
                    }
                })
            })

            // this.dateArr =Array.from(new Set(this.dateArr))
            // this.floatArr =Array.from(new Set(this.floatArr))


            // this.dateArr = checked.filter((item) => {
            //     return item.goodsSingleInfo.isExpired === 1 
            // })
            // this.floatArr = checked.filter((item) => {
            //     return item.priceFloatInfo.sign 
            // })
            console.log(this.dateArr, this.floatArr);
            if (this.dateArr.length || this.floatArr.length) {
                this.dateDialog = true
            } else {
                this.$router.push(`/orderInfo?isPreSell=${this.preChecked.length ? 1 : 0}`)
            }
            // this.$router.push('/orderInfo')
        },
        goDetail(id) {
            window.open(`${this.baseURL}/hr/#/goodsDetail?goodsId=${id}&isPreSell=0`)
        },
        goPreDetail(id) {
            window.open(`${this.baseURL}/hr/#/goodsDetail?goodsId=${id}&isPreSell=1`)

        },
        // 一键采购
        async buyAll() {
            if (this.$store.state.memberInfo.isMain == 1) {
                const res = await this.$api.storeList({ goodsId: 1 })
                console.log(res);
                if (res.data.code == 200) {
                    res.data.data.multipleMemberInfo.forEach(item => {
                        if (item.isMain) {
                            item.checked = true
                        } else {
                            item.checked = false
                        }

                    })
                }
                this.stores = res.data.data.multipleMemberInfo
            }

            this.buyAllDialog = true
        },
        // 处理文件选择
        handleFileChange(file) {
            console.log(file)
            this.selectedFile = file.raw
            this.uploadedFileName = file.name
            // 重置导入结果
            this.importResult = {
                success: 0,
                failed: 0,
                completed: false,
                details: []
            }
        },
        // 导入文件
        async importFile() {
            if (this.stores.length && this.stores.filter(item => item.checked).length === 0) return this.$message({
                type: 'warning', // success error warning
                message: '请选择门店'
            })
            const arr = this.stores.filter(item => item.checked).map(item => item.memberId)
            const fd = new FormData()
            fd.append('batchCarFile', this.selectedFile)
            // arr.forEach((item, index) => {
            //     fd.append(`memberIds[${index}]`, item)
            // })
            if (this.$store.state.memberInfo.isMain == 1) {
                fd.append('memberIds', `[${arr.join(',')}]`)
            } else {
                fd.append('memberIds', `[${this.$store.state.memberInfo.memberId}]`)
            }
            const res = await this.$api.uploadAllData(fd)
            if (res.data.code == 200) {
                this.$message({
                    type: 'success',
                    message: '导入成功'
                })
                this.responseId = res.data.data.responseId
                const details = []
                if (res.data.data.multipleCartNoticeResp.length) {
                    res.data.data.multipleCartNoticeResp.forEach(item => {
                        if (item.cartNoticeResp.length > 0) {
                            item.cartNoticeResp.forEach(item1 => {
                                // goodsCodes 与 goodsInfo 按 index 一一对应，组装成同级对象编入 details
                                const codes = item1.goodsCodes || []
                                const infos = item1.goodsInfo || []
                                const pairCount = Math.max(codes.length, infos.length)
                                for (let i = 0; i < pairCount; i++) {
                                    details.push({
                                        goodsCode: codes[i] || '',
                                        goodInfo: infos[i] || '',
                                        companyName: item.companyName,
                                        message: item1.message || ''
                                    })
                                }
                            })
                        }
                    })
                }
                this.importResult = {
                    success: res.data.data.multipleCartNoticeResp.reduce((a, b) => a + b.successCount, 0),
                    failed: res.data.data.multipleCartNoticeResp.reduce((a, b) => a + b.failCount, 0),
                    completed: true,
                    details
                }
            }
            // 模拟导入过程
            // setTimeout(

            // 模拟导入过程
            // setTimeout(() => {
            //     // 设置导入结果
            //     this.importResult = {
            //         success: 10,
            //         failed: 30,
            //         completed: true,
            //         details: [
            //             {
            //                 index: 1,
            //                 code: '2334757817',
            //                 name: '阿莫西林',
            //                 quantity: 100,
            //                 failedStores: 'A1门店、B1门店',
            //                 errorReason: '未找到该商品'
            //             },
            //             {
            //                 index: 2,
            //                 code: '2334757813241',
            //                 name: '布洛芬缓释胶囊',
            //                 quantity: 300,
            //                 failedStores: 'A1门店',
            //                 errorReason: '库存不足'
            //             }
            //         ]
            //     }
            // }, 1000)
        },
        // 一键采购弹窗关闭时的处理
        async handleBuyAllClose() {
            // 清空选择的文件
            this.selectedFile = null
            // 清空上传的文件名
            this.uploadedFileName = ''
            // 重置导入结果
            this.importResult = {
                success: 0,
                failed: 0,
                completed: false,
                details: []
            }
            // 重置门店选择状态
            this.stores.forEach(store => {
                // 保持默认选中状态（如果不是主店账号登录，默认勾选当前登录的门店账号）
                // 这里简单恢复为初始状态
                store.checked = false // 恢复初始选中的门店
            })
            await this.getShopCar()
            this.update()
        },

    },

}
</script>

<style lang="scss" scoped>
.bpre {
    position: absolute;
    right: 15px;
    top: -40px;
    background: url('../../assets/images/shopCar/bpre.svg') no-repeat;
    font-family: PingFang SC, PingFang SC;
    font-size: 14px;
    color: #f7d5ff;
    width: 233px;
    height: 30px;
    padding-left: 30px;
    box-sizing: border-box;
    line-height: 30px;
}
.ispad {
    padding-bottom: 10px;
}
.no-pointer {
    pointer-events: none;
}
.select {
    width: 150px;
    height: 60px;
}
.sketch_content {
    // 必须有高度 overflow 为自动
    overflow: auto;
    max-height: 400px;
    border-top: 1px solid #eff1f4;
    border-bottom: 1px solid #eff1f4;
    // padding: 0px 30px 11px 27px;

    // 滚动条的样式,宽高分别对应横竖滚动条的尺寸
    &::-webkit-scrollbar {
        width: 3px;
    }

    // 滚动条里面默认的小方块,自定义样式
    &::-webkit-scrollbar-thumb {
        background: #8798af;
        border-radius: 2px;
    }

    // 滚动条里面的轨道
    &::-webkit-scrollbar-track {
        background: transparent;
    }
}
.tejia {
    width: 30px;
    height: 17px;
    background: #fae5e5;
    border-radius: 2px 2px 2px 2px;
    border: 1px solid #eeeeee;
    font-weight: bold;
    font-size: 10px;
    color: #f92b2b;
    line-height: 17px;
    text-align: center;
    box-sizing: border-box;
    margin-right: 10px;
}
.mz {
    width: 30px;
    height: 17px;
    // background: #fae5e5;
    border-radius: 2px 2px 2px 2px;
    // border: 1px solid #eeeeee;
    font-weight: bold;
    font-size: 10px;
    background: rgba(248, 240, 223, 0.9);
    border: 1px solid #fad894;
    color: #f7a400;
    line-height: 17px;
    text-align: center;
    box-sizing: border-box;
    margin-right: 10px;
}
.selected {
    background: #f5fbff;
}
.lastone {
    border-bottom: none !important;
}
.firstone {
    border-top: none !important;
}
.donate {
    // height: 42px;
    padding: 10px 0px;
    background: #fef9f1;
    border-radius: 4px;
    border: 1px solid #f8f2e7;
    margin: 0px 50px;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #7a5611;
}
.donate-pink {
    // height: 42px;
    padding: 10px 0px;
    background: #fef2f8;
    border-radius: 4px;
    border: 1px solid #f8f2e7;
    margin: 0px 50px;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #ff2389;
}
::v-deep.el-input-number .el-input__inner {
    font-weight: bold !important;
    font-size: 16px !important;
    color: #333333 !important;
}

.delete {
    &:hover {
        color: #999;
    }
}
.collect {
    &:hover {
        color: #999;
    }
}

/* 一键采购弹框样式 */
.buy-all-steps {
    padding: 20px 0;
}

.step-item {
    display: flex;
    margin-bottom: 30px;
}

.step-number {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #1a9dff;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    margin-right: 20px;
    flex-shrink: 0;
}

.step-content {
    flex: 1;
}

.step-title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 8px;
    color: #333;
}

.step-desc {
    font-size: 14px;
    color: #666;
    margin-bottom: 15px;
}

.store-list {
    max-height: 200px;
    overflow-y: auto;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    padding: 10px;
}

.store-item {
    margin-bottom: 10px;
}

.upload-area {
    margin-top: 10px;
}

.tip-info {
    margin-top: 20px;
    padding: 10px;
    background: #f5f7fa;
    border-left: 4px solid #ff4d4f;
    border-radius: 4px;
}

/* 导入文件相关样式 */
.file-name {
    margin-top: 10px;
    font-size: 14px;
    color: #666;
}

.result-summary {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
}

.result-table {
    max-height: 300px;
    overflow-y: auto;
}

::v-deep.el-table th {
    background-color: #f5f7fa;
    font-weight: 600;
}

::v-deep.el-table td {
    font-size: 14px;
}
</style>
<style lang="scss">
.else-dialog {
    .el-dialog__header {
        .el-dialog__title {
            font-weight: bold !important;
            font-size: 25px !important;
            color: #1a1a1a !important;
        }
    }

    .el-dialog {
        border-radius: 10px 10px 10px 10px !important;
    }
}
</style>